import { z } from 'zod'

export const competentCourtSchema = z.object({
  id: z.string(),
  label: z.string(),
  name: z.string(),
});
export type CompetentCourt = z.infer<typeof competentCourtSchema>;

export const representativeTypeSchema = z.object({
  id: z.number().int(),
  code: z.string(),
  registration_office_id: z.number().int().nullable().optional(),
  is_agent: z.boolean(),
  name: z.string(),
  label: z.string(),
  type: z.union([z.literal('org'), z.literal('ind')]),
  match_reference: z.array(z.string()),
});
export type RepresentativeType = z.infer<typeof representativeTypeSchema>;

export const registrationOfficeSchema = z.object({
  id: z.string(),
  internal_id: z.string().optional(),
  label: z.string(),
  name: z.string(),
});
export type RegistrationOffice = z.infer<typeof registrationOfficeSchema>;

export const partyTypeSchema = z.object({
  id: z.number().int(),
  internal_id: z.string(),
  code: z.string().nullable().optional(),
  type: z.enum(['org', 'ind']),
  registration_office_id: z.number().int(),
  name: z.string(),
  label: z.string(),
  match_reference: z.array(z.string()),
});
export type PartyType = z.infer<typeof partyTypeSchema>;

export const claimTypeSchema = z.object({
  id: z.number().int(),
  internal_id: z.string(),
  label: z.string(),
  code: z.string(),
  name: z.string(),
  // legalBaseWhiteList: z.array(z.string()).optional(),
});
export type ClaimType = z.infer<typeof claimTypeSchema>;

export const claimTypeLegalRelationshipSchema = z.object({
  claim_type_id: z.number().int(),
  legal_relationship_id: z.number().int(),
});
export type ClaimTypeLegalRelationship = z.infer<typeof claimTypeLegalRelationshipSchema>;

export const legalRelationshipSchema = z.object({
  id: z.number().int(),
  label: z.string(),
  code: z.number().int(),
  name: z.string(),
});
export type LegalRelationship = z.infer<typeof legalRelationshipSchema>;

export const claimEvidenceTypeSchema = z.object({
  id: z.string(),
  label: z.string(),
  code: z.string(),
  name: z.string(),
});
export type ClaimEvidenceType = z.infer<typeof claimEvidenceTypeSchema>;

export const integrationSchema = z.literal('PayeeToken');
export type Integration = z.infer<typeof integrationSchema>;

export const toneOfVoiceSchema = z.union([
  z.literal('friendly'),
  z.literal('formal'),
]);
export type ToneOfVoice = z.infer<typeof toneOfVoiceSchema>;

export const claimInterestPeriodSchema = z.union([
  z.literal('1 - éves'),
  z.literal('2 - féléves'),
  z.literal('3 - negyedéves'),
  z.literal('4 - havi'),
  z.literal('5 - heti'),
  z.literal('6 - napi'),
  z.literal('999 - egyéb (kérjük nevezze meg)'),
]);
export type ClaimInterestPeriod = z.infer<typeof claimInterestPeriodSchema>;

export const claimInterestTypeSchema = z.any();
export type ClaimInterestType = z.infer<typeof claimInterestTypeSchema>;

export const languageSchema = z.object({
  id: z.string(),
  label: z.string(),
  countryCode: z.string(),
});
export type Language = z.infer<typeof languageSchema>;

export const exchangeRateSchema = z.object({
  rate: z.number(),
  curr: z.string(),
});
export type ExchangeRate = z.infer<typeof exchangeRateSchema>;

export const serviceSchema = z.object({});
export type Service = z.infer<typeof serviceSchema>;

export const UserSources = [
  'ORGANIC',
  'RAPID_SERVICE_HARD',
  'UNKNOWN_PARTNER',
  'PLUGIN_CASHBOOK',
  'PLUGIN_QUICK',
  'PLUGIN_SZAMLAZZHU',
  'PLUGIN_STRIPE',
  'PLUGIN_BILLINGO',
  'PARTNER_PENTECH',
  'PARTNER_MINNER',
  'PLUGIN_CASHMAN',
  'PLUGIN_EHAZ',
] as const;
export type UserSource = typeof UserSources[number];
